import React, { useEffect, useState } from 'react';
import CustomTimeline from '../../Components/CustomTimeline';
import aboutContent from '../../Data/aboutContent';
import Card from '../../Components/Cards';

const MainContent = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    setContent(aboutContent);
  }, []);

  if (!content) {
    return <div>Loading...</div>;
  }

  return (
    <main className="min-h-screen font-ubuntu text-black p-5">
      <div className="flex flex-col xl:flex-row items-center justify-between mb-10">
        <img src={content.mainImage} alt="Commercial Vehicles" className="max-w-full md:max-w-2/5 h-auto mb-5 md:mb-0 md:mr-5 rounded-lg shadow-md" />
        <div className="max-w-full m:max-w-3/5">
          <h1 className="text-3xl md:text-5xl max-xl:mt-8 text-csyellow font-bold mb-5">{content.mainHeading}</h1>
          <p className="text-lg md:text-xl font-thin mb-5">{content.mainContent}</p>
        </div>
      </div>
      <div className="flex flex-wrap justify-around mt-5 mb-10">
        {content.metrics.map((metric, index) => (
          <div key={index} className="text-center mb-5 transform transition-transform duration-300 hover:scale-105">
            <span className="block text-4xl text-csyellow font-bold">{metric.number}</span>
            <span className="block text-lg">{metric.text}</span>
          </div>
        ))}
      </div>

      <section className="py-6 text-gray-900">
        <div className="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4">
          <img src="./Untitled (14).png" alt="" className="w-full h-full col-span-2 row-span-2 rounded shadow-md min-h-96 md:col-start-3 md:row-start-1 bg-gray-500 aspect-square" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="./Untitled (7).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (10).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (11).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (13).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (12).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (15).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (16).png" />
          <img alt="" className="w-full h-full rounded-md shadow-sm min-h-48 bg-gray-500 aspect-square" src="Untitled (17).png" />
          <img src="./Untitled (19).png" alt="" className="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-1 md:row-start-3 bg-gray-500 aspect-square" />
        </div>
      </section>

      <div className="flex flex-col xl:flex-row-reverse items-center justify-between mb-10">
        <img src={content.mainImage} alt="Commercial Vehicles" className="max-w-full md:max-w-2/5 h-auto mb-5 md:mb-0 md:mr-5 rounded-lg shadow-md " />
        <div className="max-w-full md:max-w-4/5 px-4">
          <h1 className="text-3xl md:text-5xl max-xl:mt-8 text-csyellow font-bold mb-5">Our Legacy</h1>
          <p className="text-lg md:text-xl font-thin mb-5">{content.legacy}</p>
          <div className="flex flex-wrap justify-around mt-5">
            {content['legacy-metrics'].map((metric, index) => (
              <div key={index} className="text-center mb-5 transform transition-transform duration-300 hover:scale-105">
                <span className="block text-4xl text-csyellow font-bold">{metric.number}</span>
                <span className="block text-lg">{metric.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="my-16">
        <CustomTimeline />
      </div>
    </main>
  );
};

export default MainContent;